import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getAdvertiser = createSelector(
  (state: Store) => state.dealManagement.commonDeal.advertiser,
  (advertiser) => advertiser,
);

export const getBrand = createSelector(
  (state: Store) => state.dealManagement.commonDeal.brand,
  (brand) => brand,
);

export const getProductCategory = createSelector(
  (state: Store) => state.dealManagement.commonDeal.productCategory,
  (productCategory) => productCategory,
);

export const getAgency = createSelector(
  (state: Store) => state.dealManagement.commonDeal.agency,
  (agency) => agency,
);

export const getSpecialist = createSelector(
  (state: Store) => state.dealManagement.commonDeal.specialist,
  (specialist) => specialist,
);
